export const ProducerStudioPreviewToolbar = function (session_nid) {
  return {
    sid: session_nid,
    is_overlay_item_detail_opened: false,
    is_theme_changed: false,
    get is_show() {
      return this.is_theme_changed && !this.is_overlay_item_detail_opened;
    },
    init() {
      this.$watch('is_show', (val) => {
        if (val) {
          $jq(`.session-content-${this.sid} .interaction_tab_popup:not('.itp-exit')`).hide();
          $jq(`.session-content-${this.sid} .sc-r2-l-r1-e2`).css('border', '3px solid green');
          this.$el.classList.remove('hide');
        } else {
          $jq(`.session-content-${this.sid} .interaction_tab_popup:not('.itp-exit')`).show();
          $jq(`.session-content-${this.sid} .sc-r2-l-r1-e2`).css('border', '');
          this.$el.classList.add('hide');
        }
      });
      document.addEventListener("theme-changed", (e) => {
        console.log('theme-changed', e);
        this.is_theme_changed = true;
      });
      document.addEventListener("theme-reseted", (e) => {
        this.is_theme_changed = false;
      });
      document.addEventListener("theme-synced", (e) => {
        this.is_theme_changed = false;
      });
      document.addEventListener("overlay-item-detail-status-changed", (e) => {
        const {detail: {isShow}} = e;
        console.log('overlay-item-detail-status-changed', e);
        this.is_overlay_item_detail_opened = isShow;
      })
    },
    onResetClick: function () {
      document.querySelector('#sn-overlay-panel-popup .reset-btn').dispatchEvent(new Event('click'));
    },
    onPushClick: function () {
      document.querySelector('#sn-overlay-panel-popup .push-btn').dispatchEvent(new Event('click'));
    },
  }
}